import axios from "~/config/axios";
import * as settings from "~/settings";

export async function createCheckoutSession(data) {
  const response = await axios.post("/createCheckoutSession", {
    cancelURL: window.location.href,
    source: "obby",
    isFree: false,
    ...data
  });

  const { paymentIntentClientSecret } = response.data;
  return {
    clientSecret: paymentIntentClientSecret,
    successUrl: `${settings.urls.api}postStripePurchase`
  };
}
